import React, {Component} from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import './search.css'
import CustomScrollbars from 'util/CustomScrollbars';
//import config from '../../../config';
import PreviewTaleModal from '../Tale/PreviewTaleModal';
import { getSourcePersonBySourcePersonIdApi } from '../../../api/sourcePerson';
import { getFileUploadByTaleIdApi } from '../../../api/upload';
import { envConfig } from '../../../environment';

class SearchResultList extends Component {
  state = {
    checked: [1],
    list:[],
    selectedTale : { userId: 0,
        area: "",
        city: "",
        taleName: "",
        taleSource : "1",
        taleText:"",
         taleSourceText : '',
         actionId : 1 ,
         numberOfWord : 0 ,
         compilerNameSurname : '',
         compilerJob:'',
         whereToCompile :'',
        uploadList:[],
          sourcePerson : {
            job :'',
            nameSurname :'',
            learnedFrom:'',
            educationLevel : '',
            placeOfBirth : '',
            birthDate:'',
            complationDate :new Date()
          }
        },
    previewTaleModalState:false,
 

  };

  handleToggle = async(event, obj) => {
   console.log("seçilen obj",obj)
   const sourcePerson = await getSourcePersonBySourcePersonIdApi(obj.sourcePersonId);
   obj.sourcePerson = sourcePerson;

   const uploadList = await getFileUploadByTaleIdApi(obj.taleId);
   obj.uploadList = uploadList;

    this.setState({
        selectedTale: obj,
        previewTaleModalState:true,
    });
  };

  componentWillReceiveProps = (nextProps)=>{
    this.setState({list:nextProps.data});
  }
  handleChangePreviewTaleModalState = () => {
    this.setState({
      previewTaleModalState: !this.state.previewTaleModalState
    });
  };
  render() {
      let list = [];
      list = this.state.list;
      const apiUrl = envConfig.apiUrl;
      
    return (
        <CustomScrollbars className="messages-list scrollbar" style={{height: 400,"min-width":277}}>
             <List className="list bg-light" color="primary">
                {list.map(obj =>
                <ListItem button key={obj.taleId} onClick={event => this.handleToggle(event, obj)}>
                    <Avatar alt="Remy Sharp" src={apiUrl +  obj.profileImageUrl}/>
                    <ListItemText className="br-break" primary={obj.taleName} secondary={obj.name + ' '+ obj.surname}/>
                    {/* <Badge className="mr-4 mt-2 text-uppercase" color="success" pill>Agent</Badge> */}
                </ListItem>,
                )}
            </List> 
            <PreviewTaleModal onModalClose={this.handleChangePreviewTaleModalState} open={this.state.previewTaleModalState} tale={this.state.selectedTale}></PreviewTaleModal>
      </CustomScrollbars>
     
    );
  }
}

export default SearchResultList;